function initVoicetracksDataTable() {
  const table = $("#voicetracks-datatable");
  
  // Check if table exists on this page
  if (table.length === 0) {
    return;
  }
  
  // Destroy existing DataTable if it exists to prevent double initialization
  if ($.fn.DataTable.isDataTable('#voicetracks-datatable')) {
    table.DataTable().destroy();
  }
  
  table.dataTable({
    responsive: true,
    scrollCollapse: true,
    sDom: '<"row view-filter txt"<"col-sm-12 txt"<"pull-left txt"l><"pull-right txt"f><"clearfix txt">>>t<"row view-pager txt"<"col-sm-12 p-2 txt"<"text-center txt"p>>>',
    processing: true,
    serverSide: true,
    pageLength: 10,
    language: {
      stripClasses: "",
      search: '<span class="txt text-sm mr-2 mt-2">Search</span>',
      searchPlaceholder: "Enter Keywords Here...",
      lengthMenu:
        '<span class="float-right txt text-sm mt-1">Rows per page</span><select class="float-right mr-2 input input-sm rounded-sm">' +
        '<option value="10">10</option>' +
        '<option value="20">20</option>' +
        '<option value="30">30</option>' +
        '<option value="40">40</option>' +
        '<option value="50">50</option>' +
        '<option value="100">100</option>' +
        "</select>",
    },
    ajax: {
      url: table.data("source"),
    },
    pagingType: "simple_numbers",
    columns: [
      { data: "vt_name" },
      { data: "jock_name" },
      { data: "jock_id" },
      { data: "id" },
      { data: "audits", className: "white-space" }
    ],

    // pagingType is optional, if you want full pagination controls.
    // Check dataTables documentation to learn more about
    // available options.
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initVoicetracksDataTable);

// Also listen for turbo events in case Turbo gets enabled later
document.addEventListener('turbo:load', initVoicetracksDataTable);

// Clean up before page cache
document.addEventListener("turbo:before-cache", function() {
  if ($.fn.DataTable.isDataTable('#voicetracks-datatable')) {
    $("#voicetracks-datatable").DataTable().destroy();
  }
});